import { render, staticRenderFns } from "./ReplenishProducts.vue?vue&type=template&id=50f8574e&scoped=true"
import script from "./ReplenishProducts.vue?vue&type=script&lang=js"
export * from "./ReplenishProducts.vue?vue&type=script&lang=js"
import style0 from "./ReplenishProducts.vue?vue&type=style&index=0&id=50f8574e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f8574e",
  null
  
)

export default component.exports